import React, { useState, useEffect } from 'react';

const Message = ({ variant = 'info', message, onClose, timeout = 5000 }) => {
  const [isVisible, setIsVisible] = useState(true);
  
  // Define styles based on variant
  const getVariantClasses = () => {
    switch (variant) {
      case 'success':
        return 'bg-green-100 border-green-500 text-green-700';
      case 'error':
        return 'bg-red-100 border-red-500 text-red-700';
      case 'warning':
        return 'bg-yellow-100 border-yellow-500 text-yellow-700';
      case 'info':
      default:
        return 'bg-blue-100 border-blue-500 text-blue-700';
    }
  };
  
  // Auto-dismiss the message after timeout period
  useEffect(() => {
    if (timeout > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, timeout);
      
      return () => clearTimeout(timer);
    }
  }, [timeout, onClose]);
  
  // Handle close button click
  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };
  
  if (!isVisible) return null;
  
  return (
    <div className={`border-l-4 p-4 mb-4 rounded ${getVariantClasses()} relative`} role="alert">
      <button
        onClick={handleClose}
        className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
        aria-label="Close"
      >
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <p className="font-medium">{message}</p>
    </div>
  );
};

export default Message;